// eslint-disable-next-line import/no-cycle
import request from '@/utils/request';
import requestNoToken from '@/utils/requestNoToken';

// 用户、用户组管理
const userPostRequest = (fn, params) => request({
  url: `/deployment-service/user/${fn}`,
  method: 'post',
  data: params,
});
const userGetRequest = (fn, params) => request({
  url: `/deployment-service/user/${fn}`,
  method: 'get',
  params,
});
const userPostRequestNoToken = (fn, params) => requestNoToken({
  url: `/deployment-service/user/${fn}`,
  method: 'post',
  data: params,
});

// 用户管理
export function queryUser(params) {
  return userGetRequest('get_all_users', params);
}
export function queryUserInfo(params) {
  return userGetRequest('get_user_info', params);
}
export function addUser(params) {
  return userPostRequest('add_user', params);
}
export function addUserNoToken(params) {
  return userPostRequestNoToken('add_user', params);
}

export function updateUser(params) {
  return userPostRequest('update_user', params);
}

export function deleteUser(params) {
  return userPostRequest('del_user', params);
}

// 权限组管理
export function queryAuthGroup(params) {
  return userGetRequest('get_all_authgroups', params);
}
export function queryAuthGroupInfo(params) {
  return userGetRequest('get_authgroup_info', params);
}
export function addAuthGroup(params) {
  return userPostRequest('add_authgroup', params);
}

export function updateAuthGroup(params) {
  return userPostRequest('update_authgroup', params);
}

export function deleteAuthGroup(params) {
  return userPostRequest('del_authgroup', params);
}

// 用户组管理
export function queryUserGroup(params) {
  return userGetRequest('get_all_usergroups', params);
}
export function queryUserGroupInfo(params) {
  return userGetRequest('get_usergroup_info', params);
}
export function addUserGroup(params) {
  return userPostRequest('add_usergroup', params);
}

export function updateUserGroup(params) {
  return userPostRequest('update_usergroup', params);
}

export function deleteUserGroup(params) {
  return userPostRequest('del_usergroup', params);
}
export function queryDepartments(params) {
  return userGetRequest('/get_all_departments', params);
}

// 场权限管理
export function queryPlaceUser(params) {
  return request({
    url: '/deployment-service/user-project/query',
    params
  })
}
export function delPlaceUser(params) {
  return request({
    url: '/deployment-service/user-project/delete',
    method: "delete",
    params
  })
}
export function addPlaceUser(data) {
  return request({
    url: '/deployment-service/user-project/create	',
    method: 'post',
    data
  })
}